import React from 'react';
import './AliadosEstrategicos.css';

const aliados = [
  {
    logo: '/images.png',
    alt: 'YupiPass',
    label: 'Tipo de Alianza',
    desc: 'Socio publicista en Lima Norte',
  },
  {
    logo: '/COMUNICADO SBS_20230719110236.png',
    alt: 'SBS',
    label: 'Institución',
    desc: 'Superintendencia de Banca y Seguros',
  },
  {
    logo: '/logoExperianDesktop.png',
    alt: 'Experian',
    label: 'Servicio',
    desc: 'Central de riesgo crediticia',
  },
];

const AliadosEstrategicos = () => (
  <section id="aliados" className="aliados">
    <div className="aliados__header">
      <div className="eyebrow">Confianza y Respaldo</div>
      <h2 className="section-title">Aliados Estratégicos</h2>
    </div>

    <div className="aliados__grid">
      {aliados.map((a) => (
        <div className="aliado-card" key={a.alt}>
          <div className="aliado-card__logo">
            <img src={a.logo} alt={a.alt} />
          </div>
          <div className="aliado-card__info">
            <span className="aliado-card__label">{a.label}</span>
            <span className="aliado-card__desc">{a.desc}</span>
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default AliadosEstrategicos;
